export default "__VITE_ASSET__rXzDIb9M__"